var _rect, _rect2, _rect3, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckUpBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23077,
    y: 2.23077,
    width: 42.5385,
    height: 42.5385,
    rx: 21.2692,
    fill: "url(#paint0_linear_0_117)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23077,
    y: 2.23077,
    width: 42.5385,
    height: 42.5385,
    rx: 21.2692,
    stroke: "white",
    strokeWidth: 1.53846
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5016,
    cy: 23.4996,
    r: 16.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9578 18.117H29.5868C29.6243 18.0853 29.6628 18.0545 29.6993 18.0209C29.9911 17.7616 30.2263 17.4449 30.3902 17.0905C30.554 16.7362 30.643 16.3519 30.6516 15.9616C30.6642 15.5346 30.5894 15.1096 30.4318 14.7125C30.2742 14.3155 30.0372 13.9549 29.7352 13.6528C29.4332 13.3507 29.0726 13.1135 28.6756 12.9558C28.2786 12.7981 27.8536 12.7232 27.4267 12.7357C27.0362 12.7441 26.6517 12.833 26.2972 12.9969C25.9427 13.1608 25.6258 13.396 25.3664 13.688C25.0075 14.104 24.7157 14.5735 24.5016 15.0794C24.2874 14.5735 23.9956 14.104 23.6367 13.688C23.3773 13.396 23.0605 13.1608 22.7059 12.9969C22.3514 12.833 21.9669 12.7441 21.5765 12.7357C21.1495 12.7232 20.7245 12.7981 20.3275 12.9558C19.9305 13.1135 19.57 13.3507 19.268 13.6528C18.966 13.9549 18.7289 14.3155 18.5713 14.7125C18.4137 15.1096 18.3389 15.5346 18.3516 15.9616C18.3601 16.3519 18.4491 16.7362 18.6129 17.0905C18.7768 17.4449 19.012 17.7616 19.3038 18.0209C19.3404 18.0526 19.3788 18.0833 19.4163 18.117H16.0453C15.6375 18.117 15.2465 18.279 14.9581 18.5673C14.6698 18.8556 14.5078 19.2467 14.5078 19.6545V22.7295C14.5078 23.1372 14.6698 23.5283 14.9581 23.8166C15.2465 24.105 15.6375 24.267 16.0453 24.267V30.417C16.0453 30.8247 16.2073 31.2158 16.4956 31.5041C16.784 31.7925 17.175 31.9545 17.5828 31.9545H23.3484C23.4504 31.9545 23.5481 31.914 23.6202 31.8419C23.6923 31.7698 23.7328 31.672 23.7328 31.5701V22.7295H16.0453V19.6545H23.7328V22.7295H25.2703V19.6545H32.9578V22.7295H25.2703V31.5701C25.2703 31.672 25.3108 31.7698 25.3829 31.8419C25.455 31.914 25.5527 31.9545 25.6547 31.9545H31.4203C31.8281 31.9545 32.2191 31.7925 32.5075 31.5041C32.7958 31.2158 32.9578 30.8247 32.9578 30.417V24.267C33.3656 24.267 33.7566 24.105 34.045 23.8166C34.3333 23.5283 34.4953 23.1372 34.4953 22.7295V19.6545C34.4953 19.2467 34.3333 18.8556 34.045 18.5673C33.7566 18.279 33.3656 18.117 32.9578 18.117ZM20.3224 16.8677C20.188 16.746 20.0802 16.5978 20.0058 16.4325C19.9314 16.2671 19.892 16.0881 19.89 15.9068C19.8852 15.6943 19.9228 15.4831 20.0006 15.2853C20.0784 15.0876 20.195 14.9073 20.3433 14.7552C20.4917 14.6031 20.669 14.4821 20.8647 14.3993C21.0605 14.3165 21.2707 14.2737 21.4833 14.2732H21.5303C21.7117 14.2752 21.8906 14.3146 22.056 14.389C22.2214 14.4634 22.3696 14.5712 22.4913 14.7056C23.2975 15.6166 23.5819 17.1272 23.6819 18.0612C22.744 17.9623 21.2344 17.6778 20.3224 16.8677ZM28.6826 16.8677C27.7707 17.6749 26.2572 17.9594 25.3193 18.0593C25.4337 17.0494 25.7508 15.5705 26.5195 14.7066C26.6412 14.5722 26.7894 14.4644 26.9548 14.39C27.1202 14.3156 27.2991 14.2761 27.4805 14.2742H27.5275C27.7401 14.2755 27.9502 14.3192 28.1456 14.4028C28.341 14.4864 28.5178 14.6081 28.6655 14.7609C28.8133 14.9137 28.9291 15.0944 29.0061 15.2925C29.0831 15.4906 29.1198 15.702 29.1141 15.9145C29.1109 16.0946 29.0708 16.2721 28.9963 16.4361C28.9218 16.6001 28.8143 16.747 28.6807 16.8677H28.6826Z",
    fill: "url(#paint1_linear_0_117)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_117",
    x1: 40.2021,
    y1: 3.75926,
    x2: -0.166932,
    y2: 21.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_117",
    x1: 14.5078,
    y1: 22.3444,
    x2: 33.2564,
    y2: 27.1639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB54CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E7EC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUpBanner);
export default __webpack_public_path__ + "static/media/check-up-banner.7fc5e420cf1629e150a8c0db757659eb.svg";
export { ForwardRef as ReactComponent };